The monthly performance of the index is calculated from previous month end to
current month end.
